module.exports = __webpack_public_path__ + "img/报名登记.221cf191.png";